import React, { useState, useEffect, Fragment } from 'react';
import Tippy from '@tippyjs/react';
import { getApiPageTagsUrl } from '../../utilities/urlHelper';
import editorStateToText from '../../tettra-editor/utilities/editorStateToText';
import PageGeneratedTagsModal from './PageGeneratedTagsModal';
import { hasKaiFeature } from '../../utilities/featureHelper';

const PageGeneratedTagsContainer = (props) => {
    const [tags, setTags] = useState(null);
    const [showPageTagsModal, setShowPageTagsModal] = useState(false);
    const [contentLength, setContentLength] = useState(0);

    let tagActiveRequest = null;
    let questionActiveRequest = null;

    useEffect(() => {
        getTags();
        getContentLength();
        return (() => {
            if (tagActiveRequest) {
                tagActiveRequest.abort();
            }
            if (questionActiveRequest) {
                questionActiveRequest.abort();
            }
        });
    }, [props.page]);

    const getContentLength = () => {
        if (!props.page || !props.page.editor_state) return;
        const content = editorStateToText(JSON.parse(props.page.editor_state));

        // empty page content will be '""', so check if there's still text when we replace all double quotes
        content.replaceAll('"', '').length > 0
            ? setContentLength(content.split(' ').length)
            : setContentLength(0);
    };

    const getTags = () => {
        if (!props.page || !props.page.id) return;
        setTags(null);

        if (tagActiveRequest) {
            tagActiveRequest.abort();
        }

        tagActiveRequest = $.get(getApiPageTagsUrl(props.page.id));

        return tagActiveRequest
            .done(({ tags }) => {
                setTags(tags);
            });
    };
    const tooltipText = `View ${hasKaiFeature ? 'AI generated and team' : 'all'} tags`;
    const tagsBtnText = tags?.length === 1 ? '1 Tag' : `${tags?.length} Tags`;

    return (
        <Fragment>
            <Tippy content={tooltipText} placement="bottom">
                <button
                    className="insights"
                    onClick={() => {
                        setShowPageTagsModal(true);
                    }}
                    aria-label="view ai generated tags"
                    type="button"
                >
                    <span role="img" aria-hidden="true">🏷️</span>
                    {`${tagsBtnText}`}
                </button>
            </Tippy>
            { showPageTagsModal
                && (
                    <PageGeneratedTagsModal
                        closeModal={() => setShowPageTagsModal(false)}
                        tags={tags}
                        pageContentLength={contentLength}
                        pageVisibility={props.page.visibility}
                        pageId={props.page.id}
                        updateTags={setTags}
                    />
                )}
        </Fragment>
    );
};

export default PageGeneratedTagsContainer;
